import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelModule, TableModule, TooltipModule } from 'primeng';
import { flatMap } from 'lodash';
import { JobsService } from '../../../../services';
import {
  JobScreenCarryOverJob,
  JobScreenCarryOverTask,
  JobScreenCarryOverTaskCheck,
} from '../../../../interfaces/screen-specific/job-screen';
import { TaskSupplierScheduleStore } from '../../../task-supplier-schedule/task-supplier-schedule-store';
import { CarryoverTaskInfoComponent } from './carryover-task-info.component';
import { VmeCommonModule } from '../../../../vme-common.module';
import { CarryoverApprovalAnalysisComponent } from './carryover-approval-analysis/carryover-approval-analysis.component';
import { CarryoverCheckStatus } from '../../../../enums/carryover-check-status';
import { CarryoverApprovalService } from './carryover-approval.service';

@Component({
  selector: 'job-schedule-carry-over',
  templateUrl: './job-schedule-carry-over.component.html',
  styleUrls: ['./carryover-pill.scss', 'job-screen-carry-over.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    PanelModule,
    TableModule,
    TooltipModule,
    CarryoverTaskInfoComponent,
    VmeCommonModule,
    CarryoverApprovalAnalysisComponent,
  ],
})
export class JobScheduleCarryOverComponent implements OnInit {
  @Input('jobId') jobId!: number;
  @Input('organisationId') supplierId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;
  @Input() taskSupplierScheduleStores?: Record<string, TaskSupplierScheduleStore>;

  public job: JobScreenCarryOverJob;
  public carryOverTasks: JobScreenCarryOverTask[] = [];
  public showCarryOverTasks = false;
  public loadingConditions = true;

  constructor(
    private jobService: JobsService,
    private carryoverApprovalService: CarryoverApprovalService,
  ) {}

  async ngOnInit() {
    try {
      await this.getJob(this.jobId);
    } catch (error) {
      console.error('Failed to fetch job:', error);
    }
  }

  private async getJob(jobId: number): Promise<void> {
    await this.jobService.getForComponent(jobId, 'job-screen-carry-over').then((res) => {
      this.showCarryOverTasks = true;
      this.job = res as JobScreenCarryOverJob;
      this.initCarryOverTasks(this.job);

      this.carryoverApprovalService
        .checkCarryOverConditions(this.jobId, this.supplierId)
        .then((res) => {
          this.loadingConditions = false;
          if (res && res.length > 0) {
            res.forEach((taskCheck) => {
              const task = this.carryOverTasks.find((y) => y.id === taskCheck.taskId);
              if (task) {
                task.preApproveCarryover = taskCheck;
              }
            });
          }
        });
    });
  }

  initCarryOverTasks(job: JobScreenCarryOverJob): void {
    this.carryOverTasks = flatMap(job?.orders, (o) => o?.tasks.map((t) => ({ ...t, order: o })));
  }

  typedTaskInfo(item: JobScreenCarryOverTask): JobScreenCarryOverTask {
    return item;
  }

  missingConditions(preApproveCarryover: JobScreenCarryOverTaskCheck) {
    return preApproveCarryover.steps.filter((x) => x.status == CarryoverCheckStatus.Failed).length;
  }
}
